module.exports = __webpack_public_path__ + "static/img/02_07.e683319.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/alipay/02_07.png
// module id = YMOR
// module chunks = 1